<template>
  <div>
    <el-container>
      <sub-header :subHeaderConfig="subHeaderConfig" />
    </el-container>
    <el-container>
      <v-card id="subbrandListTable" class="y-data-table" style="width:100%; margin:20px">
        <v-data-table
          class="justify-center"
          must-sort
          :headers="headers"
          :items="channelListData"
          :header-props="{
                  sortIcon: 'arrow_drop_down'
                }"
          sort-desc
          hide-default-footer
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td class="subbrand-name-value">
                  <span class="subbrand-name">{{ item.name }}</span>
                </td>
                <td>
                  <span>{{ item.cobrandId }}</span>
                </td>
                <td>
                  <span>{{ item.appext }}</span>
                </td>
                <td>
                  <span class="formatDate">{{ item.updatedOn | formatDate }}</span>
                  <span class="time">{{ item.updatedOn | formatDateTime }}</span>
                </td>
                <td class="text-center action-buttons">
                  <v-btn
                    autoid="btn-edit-sub-brand"
                    color="primary"
                    outlined
                    @click="editChannelConfig(item)"
                    class="edit-btn"
                  >Edit</v-btn>

                   <v-btn
                      color="primary"
                      outlined
                      class="label-upload-btn"
                      autoid="btn-customize-apps"
                    >
                    <config-upload :removeHandler="deleteLabel" :beforeUploadHandler="()=>{}" ref="configUpload" :updateBtnText="item.brand ? true : false" :fileUploadProps="(() => { return defaultChannelProps(item)})()" :uploadHandler="submitUploadLabel"></config-upload> 
                  </v-btn>

                </td>
              </tr>
              <tr v-if="items.length == 0">
                <td class="text-lg-center no-result" colspan="5">No Results found</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-card>
    </el-container>
  </div>
</template>

<script>
import _ from 'underscore'
import moment from 'moment'
import SubHeader from '../../components/subheader.vue'
import { jsonHelper } from '../../mixins/jsonHelper'
import yFileUploadPopup from '../../components/yFileUploadPopup'
import serviceRegistery from '../../mixins/serviceRegistery'
export default {
  components: {
    'sub-header': SubHeader,
    'config-upload': yFileUploadPopup
  },
  mixins: [jsonHelper],
  props: {},
  data() {
    return {
      headers: [
        {
          text: 'Channel Name',
          align: 'start',
          sortable: true,
          value: 'name',
          width: '20%'
        },
        {
          text: 'Channel Id',
          align: 'start',
          sortable: true,
          value: 'cobrandId',
          width: '20%'
        },
        {
          text: 'App Ext',
          align: 'start',
          value: 'appext',
          sortable: false,
          width: '20%'
        },
        {
          text: 'Last Updated',
          align: 'start',
          sortable: true,
          value: 'updatedOn',
          width: '30%'
        },
        {
          text: '',
          value: '',
          sortable: false,
          align: 'center',
          width: '10%'
        }
      ]
    }
  },
  created() {},
  computed: {
    subHeaderConfig() {
      let config = {
        headerText: 'Channels',
        actions: [
          {
            displayName: 'Create Channel Config',
            controlName: 'button',
            actionType: 'primary',
            actionLink: {
              name: 'channelConfig',
              params: {
                isEdit: false,
                backLink: '/channel/channelDataloader',
                backText: 'Back to Channel List'
              }
            }
          }
        ]
      }
      return config
    },
    channelListData() {
      return this.$store.state.channelStore.channelListData
    },
    defaultPopupProps() {
      let yPopupProps = {
          "displayName": "",
          "displayLinkName": this.$lang.messages.form_btn_upload_config_zip,
          "displayUpdateLinkName": this.$lang.messages.form_btn_reupload_config_zip,
          "defaultValue": "",
          "id": "labelconfigid",
          "prefix": "labelconfig",
          "autoid": "channel-list-page-label-config-upload-btn",
          "popupProps": {
              "customClasses": "test-popup-class",
              "showPopup": false,
              "accept": ".zip",
              "isValid": true,
              "errorMessage": "",
              "buttonName": "Upload",
              "isInfo": true,
              "infoMessage": ""
          }
      }
      return yPopupProps
    }
  },
  filters: {
    formatDate: function(value) {
      let today = new Date().toLocaleDateString()
      let lastUpdated = new Date(value).toLocaleDateString()
      if (today == lastUpdated) {
        return 'Today'
      } else {
        return new moment(String(value)).format('DD MMM YYYY')
      }
    },
    formatDateTime: function(value) {
      if (value) {
        return new moment(String(value)).format('hh:mm a')
      }
    }
  },
  methods: {
    editChannelConfig(channelInfo) {
      console.log('EDIT CHANNEL')
      this.$store.state.channelStore.selectedChannelInfo = channelInfo
      this.getChannelInfo(
        channelInfo,
        this.routeToEditChannelSuccess,
        this.routeToEditChannelFailure
      )
    },
    routeToEditChannelSuccess() {
      this.$router.push({
        name: 'channelConfig',
        params: {
          backLink: '/channel/channelDataloader',
          backText: 'Back to Channel List'
        }
      })
    },
    routeToEditChannelFailure() {
      console.log('Error')
    },
    defaultChannelProps(item) {
      this.uploadIndex = this.channelListData.indexOf(item);
      this.channelItemInfo = Object.assign({}, item)
      var zipUploadData = JSON.parse(
        JSON.stringify(this.defaultPopupProps)
      )
      zipUploadData.channelInfo = this.channelItemInfo
      zipUploadData.channelitemIndex =  this.uploadIndex
      return zipUploadData;
    },
    deleteLabel(scope, files, componentArg) {
      let component = componentArg
      component.popupProps.errorMessage = ''
      component.popupProps.isValid = true
    },
    submitUploadLabel(scope, files, componentArg) {
      let fileList = files
      var self = this
      let ext
      let component = componentArg

      if (fileList.length <= 0) {
        component.popupProps.isValid = false
        component.popupProps.errorMessage = 'Please select the file'
      } else if (/\.(zip)$/i.test(fileList[0].name) === false) {
        component.popupProps.isValid = false
        component.popupProps.errorMessage =
          'Please select the correct font file(.zip)'
      } else {
        
          component.popupProps.errorMessage = ''
          component.popupProps.isValid = true

          if (!fileList.length) return

          const formData = new FormData()

          Array.from(Array(fileList.length).keys()).map(x => {
            fileList[x].name = component.prefix + '-' + fileList[x].name
            formData.append('resource', fileList[x].raw, fileList[x].name)
            ext = fileList[x].name.split('.').pop()
            formData.append('format', ext)
          })
          formData.append(
            'id',
            component.channelInfo._id
          )
          serviceRegistery
            .makeCall({
              method: 'PUT',
              url: this.$hostname + 'services/channel/label',
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then(response => {
              self.$refs.configUpload[component.channelitemIndex].updateUploadText = true;
              Object.assign(self.channelListData[component.channelitemIndex], response.data)
              component.popupProps.isPopupOpen = true
              component.popupProps.isPopupOpen = false
              self.showToastMessage(
                'Label uploaded successfully.'
              )
              if (self.$refs.uploadFont) self.$refs.uploadFont.clearFiles()
            })
            .catch(error => {
              console.log('submit file')
              component.popupProps.isPopupOpen = true
              component.popupProps.isPopupOpen = false
              if (self.$refs.uploadFont) self.$refs.uploadFont.clearFiles()
              self.showToastMessage(
                'Sorry, a technical error has occurred! Please try again later.'
              )
            })
        
      }
    }
  }
}
</script>

<style lang="scss">
#subbrandListTable .action-buttons a.uploadFontBtn span {
  font-weight: normal !important;
}
.v-btn.label-upload-btn {
  padding: 0 !important;
  .file-uploader-popup-inner .uploadFontBtn {
    padding: 0 16px;
    line-height: 32px;
  }
}
</style>